import { useTranslations } from 'next-intl';

import { getBookingHref } from '@/lib/config/site';

export interface BookingLinkProps {
  href: string;
  target?: '_blank';
  rel?: string;
}

/**
 * Link props for a booking CTA. A web booking page opens in a new tab; the
 * `mailto:` fallback opens in place so no empty tab is left behind.
 * No 'use client' directive: it also runs in non-async server components.
 */
export function useBookingLink(): BookingLinkProps {
  const t = useTranslations('landing.booking');
  const href = getBookingHref(t('mailSubject'));

  if (/^https?:\/\//i.test(href)) {
    return { href, target: '_blank', rel: 'noopener noreferrer' };
  }
  return { href };
}
